
import { Component, Prop } from 'vue-property-decorator'
import AppInput from '@/components/AppInput.vue'
import { integrationModuleEntity } from '@/models/models'
import { ChildComponentMixin } from '@/mixins'
import { cloneDeep } from 'lodash'

@Component({
    components: {
        AppInput,
    },
})

export default class IntegrationFormAdditionalData extends ChildComponentMixin {
    @Prop() public value?: IntegrationModuleEntity

    get integrationModule(): IntegrationModuleEntity {
        return this.value ?? integrationModuleEntity
    }

    get nameOptions(): InputSelectOptionEntity[] {
        const partners = cloneDeep(this.$store.state.integrationForm.modulepartners)

        const allNames = partners.map((partner: ModulepartnerEntity) => {
            return partner.name
        })

        const names = allNames.filter((name: string, index: number) => {
            return allNames.indexOf(name) === index
        })

        return names.map((name: string) => {
            return { value: name, text: '' }
        })
    }

    get websiteOptions(): InputSelectOptionEntity[] {
        const partners = cloneDeep(this.$store.state.integrationForm.modulepartners)

        const allWebsites = partners.filter((partner: ModulepartnerEntity) => {
            return (
                partner.name === this.integrationModule.partner!.name &&
                partner.website !== null && partner.website !== ''
            )
        }).map((partner: ModulepartnerEntity) => {
            return partner.website
        })

        const websites = allWebsites.filter((website: string, index: number) => {
            return allWebsites.indexOf(website) === index
        })

        return websites.map((website: string) => {
            return { value: website, text: '' }
        })
    }

    get typeSupportContactOptions() {
        return [
            { value: 'EMAIL', text: 'E-mail' },
            { value: 'PHONE', text: 'Telefone' },
            { value: 'PAGE', text: 'Página da Web' },
            { value: 'DD', text: 'Time Delivery Direto' },
        ]
    }

    get supportContactOptions(): InputSelectOptionEntity[] {
        const partners = cloneDeep(this.$store.state.integrationForm.modulepartners)

        const allContacts = partners.filter((partner: ModulepartnerEntity) => {
            return (
                partner.name === this.integrationModule.partner!.name &&
                partner.typeSupportContact === this.integrationModule.partner!.typeSupportContact &&
                partner.supportContact !== null && partner.supportContact !== ''
            )
        }).map((partner: ModulepartnerEntity) => {
            return partner.supportContact
        })

        const contacts = allContacts.filter((contact: string, index: number) => {
            return allContacts.indexOf(contact) === index
        })

        return contacts.map((contact: string) => {
            return { value: contact, text: '' }
        })
    }
}
